import commonStrings from '../../resources/commonStrings';
const rlpMapReports = 'rlp-map-reports';

export const growthReportResources = [
  {
    title: commonStrings.reportResourceSectionTitle.normsAndComparativeData,
    resources: [
      {
        link: {
          displayText: commonStrings.reportResourceLink.nweaMapGrowthNormData,
          target: 'https://teach.mapnwea.org/impl/MAPGrowthNormativeDataOverview.pdf',
        },
        description: commonStrings.reportResourceDescription.nweaMapGrowthNormData,
        analytics: {
          category: rlpMapReports,
          label: 'nwea-map-growth-norms-study',
        },
      },
      {
        link: {
          displayText: commonStrings.reportResourceLink.comparativeDataToInformInstruction,
          target: 'https://teach.mapnwea.org/impl/MAPGrowthComparativeData.pdf',
        },
        description: commonStrings.reportResourceDescription.comparativeDataToInformInstruction,
        analytics: {
          category: rlpMapReports,
          label: 'comparative-data-to-inform-instruction',
        },
      },
      {
        link: {
          displayText: commonStrings.reportResourceLink.normsAndStandardsResearchStudies,
          target: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=692',
        },
        description: commonStrings.reportResourceDescription.normsAndStandardsResearchStudies,
        analytics: {
          category: rlpMapReports,
          label: 'norms-standards-research-studies',
        },
      },
    ],
  },
  {
    title: commonStrings.reportResourceSectionTitle.community,
    resources: [
      {
        link: {
          displayText: commonStrings.reportResourceLink.nweaConnection,
          target: 'https://community.nwea.org/',
        },
        description: commonStrings.reportResourceDescription.nweaConnection,
        analytics: {
          category: rlpMapReports,
          label: 'nwea-connection',
        },
      },
    ],
  },
  {
    title: commonStrings.reportResourceSectionTitle.whichReportsDoIWant,
    resources: [
      {
        link: {
          displayText: commonStrings.reportResourceLink.quickReferenceMapReportsSummary,
          target: 'https://teach.mapnwea.org/assist/doc/QRM2_MAP_Reports_Summary_QuickRef.pdf',
        },
        description: commonStrings.reportResourceDescription.quickReferenceMapReportsSummary,
        analytics: {
          category: rlpMapReports,
          label: 'quick-reference-map-reports-summary',
        },
      },

      {
        link: {
          displayText: commonStrings.reportResourceLink.mapGrowthReportsPortfolio,
          target: 'https://www.nwea.org/resource-center/resource/map-growth-reports-portfolio/',
        },
        description: commonStrings.reportResourceDescription.mapGrowthReportsPortfolio,
        analytics: {
          category: rlpMapReports,
          label: 'sample-map-reports',
        },
      },
    ],
  },
  {
    title: commonStrings.reportResourceSectionTitle.howDoIGetHelp,
    resources: [
      {
        link: {
          displayText: commonStrings.reportResourceLink.reportsBasic,
          target: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=851',
        },
        description: commonStrings.reportResourceDescription.reportsBasic,
        analytics: {
          category: rlpMapReports,
          label: 'reports-basic',
        },
      },

      {
        link: {
          displayText: commonStrings.reportResourceLink.reportsTroubelshooting,
          target: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=686',
        },
        description: commonStrings.reportResourceDescription.reportsTroubelshooting,
        analytics: {
          category: rlpMapReports,
          label: 'reports-troubleshooting',
        },
      },
    ],
  },
  {
    title: commonStrings.reportResourceSectionTitle.howDoIUnderstandResults,
    resources: [
      {
        link: {
          displayText: commonStrings.reportResourceLink.reportsVideo,
          target: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=1033',
        },
        description: commonStrings.reportResourceDescription.reportsVideo,
        analytics: {
          category: rlpMapReports,
          label: 'reports-informational-videos',
        },
      },
    ],
  },
];

export default growthReportResources;
